/**
 * Обрезает слишком длинный текст и к концу строки добавляется многоточие.
 * @param text Исходный текст
 * @param maxLength максимальная длина строки
 * @returns строка длиной не более чем указанную в maxLength
 */
export function ellipsis(text: string, maxLength: number): string {
  return text.length > maxLength ? `${text.slice(0, maxLength - 1)}…` : text;
}
